import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ToastrService } from 'ngx-toastr';
import { first, map, merge, tap } from 'rxjs';
import { Subject } from 'rxjs/internal/Subject';
import { ModalDataService } from 'src/app/services/global/modal-data.service';
import { GlobalService } from 'src/app/services/index.service';
import { AngularMaterialModule } from 'src/app/shared/angular-material/angular-material.module';
import { AreYouSureComponent } from 'src/app/shared/components/modals/are-you-sure/are-you-sure.component';
import { SharedModule } from 'src/app/shared/components/shared.module';
import { IEditEntity } from 'src/app/shared/interfaces/index.interface';
import { PipsModule } from 'src/app/shared/pips/pips.module';

@Component({
  selector: 'app-edit-profile-header-modal',
  templateUrl: './edit-profile-header-modal.component.html',
  styleUrls: ['./edit-profile-header-modal.component.scss'],
  standalone: true,
  imports: [
    AngularMaterialModule,
    PipsModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    SharedModule
  ]
})
export class EditProfileHeaderModalComponent implements OnInit, OnDestroy, AfterViewInit {
  isSubmitted: boolean = false;
  formValidator: IEditEntity = <IEditEntity>{}
  formData: IEditEntity = <IEditEntity>{};
  errorObject: { text: string, type: string } = <{ text: string, type: string }>{}
  errorObjectFirstName = ''
  errorObjectLastName = ''
  charCounter: any = {
    first_name: 0,
    last_name: 0,
    organ_name: 0,
    location: 0,
    slogan: 0,
    info: 0,
  }
  editFormPerson = this.formBuilder.group({
    first_name: new UntypedFormControl(this.data.item.first_name, [Validators.required, Validators.minLength(2)]),
    last_name: new UntypedFormControl(this.data.item.last_name, [Validators.required, Validators.minLength(2)]),
    profile_text: new UntypedFormControl(this.data.item.profile_text),
    info: new UntypedFormControl(this.data.item.info),
    city: new UntypedFormControl(this.data.item.city),
  });
  editEntityEmiiter: EventEmitter<IEditEntity> = new EventEmitter<IEditEntity>();
  item: IEditEntity = <IEditEntity>{}
  getCurrentCharacter(e: Event, input: string) {
    this.charCounter[input] = (<HTMLInputElement>e.target).value.length
  }

  constructor(
    private formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public modalService: ModalDataService,
    public dialogSure: MatDialogRef<AreYouSureComponent>,
    private deviceDetector: DeviceDetectorService,
    private globalService: GlobalService,
    private toastrService:ToastrService
  ) { }

  ngOnInit(): void {
    this.item = Object.assign({}, this.data.item)
  }
  ngAfterViewInit() {
    let first_name = ''
    let last_name = ''
    this.editFormPerson.controls['first_name'].valueChanges.pipe(
      tap((data) => { first_name = data }),
      map((data) => { return this.globalService?.convertDegitAndSignChar(data.toString()) }),
    ).subscribe((data) => {
      this.editFormPerson.controls['first_name'].setValue(data, { emitEvent: false })
      if (first_name != data) {
        this.errorObjectFirstName = '(لطفا از حروف فارسی استفاده کنید!)'
        first_name = ''
      }
      else {
        this.errorObjectFirstName = ''
      }
      this.formValidator['first_name'] = this.errorObjectFirstName != '' ? 'INVALID' : 'VALID'
    })
    this.editFormPerson.controls['last_name'].valueChanges.pipe(
      tap((data) => { last_name = data }),
      map((data) => { return this.globalService?.convertDegitAndSignChar(data.toString()) }),
    ).subscribe((data) => {
      this.editFormPerson.controls['last_name'].setValue(data, { emitEvent: false })
      if (last_name != data) {
        this.errorObjectLastName = '(لطفا از حروف فارسی استفاده کنید!)'
        last_name = ''
      }
      else {
        this.errorObjectLastName = ''
      }
      this.formValidator['last_name'] = this.errorObjectLastName != '' ? 'INVALID' : 'VALID'
    })
  }
  isMobile() {
    return this.deviceDetector.isMobile()
  }

  edit() {
    this.isSubmitted = true;
    let form = this.editFormPerson
    const is_change = this.modalService.isChangeFormValue(form.value, this.data.item)
    if (is_change) {
      this.dialogSure.close();
      this.modalService.waiting = false;
    } else {
      if (form.valid) {
        let output = form.value
        output.city = form.value.city && form.value.city.id ? form.value.city.id : form.value.city && !form.value.city.id ? form.value.city.id : null
        if(output.city){
          this.modalService.waiting = true;
          this.formData = output
          this.modalService.storeEditEntity.next(output);
        }else{
          this.toastrService.error('','شهر را حتما انتخاب کنید')
        }
      } else {
        this.errorObject = <{ text: string, type: string }>{}
        Object.keys(form.controls).forEach((field: string) => {
          const control = form.get(field);
          control?.markAsTouched({ onlySelf: true });
          this.formValidator[field as keyof IEditEntity] = control?.status
        });
      }
      if (this.formValidator?.first_name == 'INVALID') {
        this.errorObjectFirstName = 'نام خود  را تکمیل کنید!'
      }
      else {
        this.errorObjectFirstName = ''
      }
      if (this.formValidator?.last_name == 'INVALID') {
        this.errorObjectLastName = 'نام‌خانوادگی خود  را تکمیل کنید!'
      }
      else {
        this.errorObjectLastName = ''
      }
    }
  }
  closeModal() {
    let form = this.editFormPerson;
    const is_change = this.modalService.isChangeFormValue(form.value, this.item)
    if (is_change) {
      this.dialogSure.close();
      this.modalService.waiting = false;
    } else {
      this.dialogRef.open(AreYouSureComponent, {
        data: {
          parentId: 'edit-profile-header',
          action: 'edit'
        }
      });
    }
  }
  getCityId(data: any) {
    if (data)
      this.editFormPerson.value.city = data
    else
      this.editFormPerson.value.city = null
  }
  ngOnDestroy(): void {
    this.modalService.storeEditEntity.unsubscribe()
    this.modalService.storeEditEntity = new Subject()
  }
  denySignCharecter(formKey: string, value: string) {
    this.editFormPerson.value[formKey as string] = this.globalService.convertDegitAndSignChar(value)
    // if (formKey == 'first_name') this.item.first_name = this.editFormPerson.value[formKey as string]
    // if (formKey == 'last_name') this.item.last_name = this.editFormPerson.value[formKey as string]
  }
}